import styled from "styled-components";

export const ModalInput = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  font-size: 0.95rem;
  margin-bottom: 0.75rem;
  transition: all 0.2s ease;
  color: #001f52;
  background-color: white;

  .dark-mode & {
    background-color: #1f1f2e;
    border-color: #3a3a4e;
    color: #e0e0e0;
  }

  &:focus {
    outline: none;
    border-color: #64da4c;
    box-shadow: 0 0 0 3px rgba(100, 218, 76, 0.1);
  }

  &::placeholder {
    color: #999;
  }

  .dark-mode &::placeholder {
    color: #666;
  }
`;

export const ModalLabel = styled.div`
  font-size: 0.85rem;
  font-weight: 600;
  color: #001f52;
  margin-bottom: 0.25rem;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #e0e0e0;
  }
`;

export const ModalButtonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  justify-content: flex-end;
`;

export const CancelButton = styled.button`
  padding: 0.6rem 1.2rem;
  border-radius: 999px;
  border: 2px solid #e0e0e0;
  cursor: pointer;
  font-weight: 600;
  background: white;
  color: #001f52;
  transition: all 0.2s ease;

  .dark-mode & {
    background: #2a2a3e;
    border-color: #3a3a4e;
    color: #e0e0e0;
  }

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }

  .dark-mode &:hover {
    background: #3a3a4e;
    border-color: #4a4a5e;
  }
`;

export const DangerButton = styled.button`
  margin: 0;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  background-color: #d32f2f;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.5;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(211, 47, 47, 0.3);

  &:hover {
    background-color: #b71c1c;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(211, 47, 47, 0.4);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(211, 47, 47, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SmallText = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.75rem;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #999;
  }
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #ff6b6b;
  }
`;
